import { render, staticRenderFns } from "./applicationTable.vue?vue&type=template&id=19d96823"
import script from "./applicationTable.vue?vue&type=script&lang=js"
export * from "./applicationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports